import { render, staticRenderFns } from "./checkout-products.vue?vue&type=template&id=2709eca7&"
import script from "./checkout-products.vue?vue&type=script&lang=js&"
export * from "./checkout-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports